import React from 'react';
import { Helmet } from 'react-helmet-async';

interface ServiceCenterSchemaProps {
  name: string;
  description: string;
  location?: {
    city: string;
    state: string;
  };
  services: string[];
}

export default function ServiceCenterSchema({
  name,
  description,
  location,
  services
}: ServiceCenterSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': 'https://parakhservices.com/#servicecenter',
    name: `${name} Service Center`,
    description,
    url: 'https://parakhservices.com',
    telephone: '+918302311436',
    email: 'contact@parakhservices.com',
    priceRange: '₹499 - ₹1499',
    address: location ? {
      '@type': 'PostalAddress',
      addressLocality: location.city,
      addressRegion: location.state,
      addressCountry: 'IN'
    } : undefined,
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '20.5937',
      longitude: '78.9629'
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday', 'Tuesday', 'Wednesday', 'Thursday',
        'Friday', 'Saturday', 'Sunday'
      ],
      opens: '00:00',
      closes: '23:59'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Repair Services',
      itemListElement: services.map(service => ({
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: service
        }
      }))
    },
    areaServed: location ? {
      '@type': 'City',
      name: location.city
    } : {
      '@type': 'Country',
      name: 'India'
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}